import { render, staticRenderFns } from "./szjd.vue?vue&type=template&id=08b6517d&scoped=true&"
import script from "./szjd.vue?vue&type=script&lang=js&"
export * from "./szjd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6517d",
  null
  
)

export default component.exports